import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product",
  "use": "icon-product-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-product\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 320l-64 0L704 288C704 164.48 603.52 64 480 64 356.48 64 256 164.48 256 288L256 320 192 320C121.6 320 64 377.6 64 448l0 384c0 70.4 57.6 128 128 128l576 0c70.4 0 128-57.6 128-128L896 448C896 377.6 838.4 320 768 320zM320 288C320 199.68 391.68 128 480 128 568.32 128 640 199.68 640 288L640 320 320 320 320 288zM832 832c0 35.2-28.8 64-64 64L192 896c-35.2 0-64-28.8-64-64L128 448c0-35.2 28.8-64 64-64l64 0 0 96C256 497.92 270.08 512 288 512 305.92 512 320 497.92 320 480L320 384l320 0 0 96C640 497.92 654.08 512 672 512 689.92 512 704 497.92 704 480L704 384l64 0c35.2 0 64 28.8 64 64L832 832z\" p-id=\"2153\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/product.svg
// module id = UHi4
// module chunks = 132